module.exports = __webpack_public_path__ + "img/no-news.daea09ce.svg";